// extracted by mini-css-extract-plugin
export default {"markdownImage":"Image_markdownImage__XGR0O","fieldImage":"Image_fieldImage__iz9Zc","imageHoverEffect":"Image_imageHoverEffect__ByQK9"};